import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductCompareTheme } from "../../../constants";
import { ProductSelectionGridCMSData } from "../../../models/product-compare";
import { check } from "../../../models/utils";
import { useSSRStorePrefill } from "../../../store/reducers";
import { usePageURL } from "../../../utils/urls";
import { ProductSelectionGrid } from "../ProductSelectionGrid";
import { prefillProductSelectionGrid } from "../ssr";

type IProps = Immutable<templates.ProductSelectionGridBlockTemplate> & {
    showStartingAt?: boolean;
};

export const ProductSelectionGridSSR = (props: IProps): React.JSX.Element => {
    useSSRStorePrefill(
        {
            base_tiles_data: props.base_tiles_data,
            products_by_id_data: props.products_by_id_data,
            initial_selected_tile_ids: props.initial_selected_tile_ids,
        },
        prefillProductSelectionGrid,
    );

    const cms = check(
        ProductSelectionGridCMSData.decode(JSON.parse(props.cms_data)),
    );
    const financeLink = usePageURL("finance_link");
    const home = usePageURL("home");

    const theme = cms.theme.theme || ProductCompareTheme.DEFAULT;
    const showStartingAt =
        props.showStartingAt ?? theme === ProductCompareTheme.THEME_ONE;

    return (
        <ProductSelectionGrid
            header={cms.header}
            financingLink={financeLink || home}
            productComparePageURL={cms.product_compare_page?.url || null}
            sizeAttributeOptionGroup={cms.size_attribute_option_group}
            preselectedSize={cms.preselected_size}
            theme={theme}
            footer={cms.footer}
            groupHeader={cms.group_columns_header?.[0] ?? null}
            showSizeSelector={cms.show_size_selector}
            showStartingAt={showStartingAt}
        />
    );
};
